import { Form } from "antd";
import TopupCategories from "../TopupCategories/TopupCategories";
import { useTopupListing } from "../../context/TopupListingContext";
import { INITIAL_TOPUP_SEARCH } from "../../constants";
import { useDebounceFn } from "src/hooks/useDebounce";

export default function Filters() {
  const { setFilters } = useTopupListing();
  const debouncedSetFilters = useDebounceFn(setFilters, 300);
  return (
    <Form initialValues={INITIAL_TOPUP_SEARCH} className="w-full" onValuesChange={debouncedSetFilters}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <TopupCategories name="categoryCode" />
      </div>
    </Form>
  );
}
